import { ProfilePk, UnixMs } from "./common"

export enum IntegrationNamesEnum {
  ADAGIN = "adagin",
  AGRIGISTICS = "agrigistics",
  PAYSPACE = "payspace",
}

export type IntegrationWarnings = {
  profilePk: ProfilePk
  name: string
  surname: string
  message: string
  logUnixMs: UnixMs
} & Record<string, any>
